import { getCurrentInstance as c, inject as f, ref as i, computed as m } from "vue";
import { buildProps as p, definePropType as C } from "./index601.js";
import { isFunction as a, isArray as v } from "./index575.js";
import { debugWarn as d } from "./index588.js";
import O from "./index712.js";
const E = /* @__PURE__ */ Symbol("emptyValuesContextKey"), V = "use-empty-values", A = ["", void 0, null], b = void 0, S = p({
  /**
   * @description empty values supported by the component
   */
  emptyValues: Array,
  /**
   * @description return value when cleared, if you want to set `undefined`, use `() => undefined`
   */
  valueOnClear: {
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-function-type */
    type: C([
      String,
      Number,
      Boolean,
      Function
    ]),
    default: void 0,
    validator: (e) => (e = a(e) ? e() : e, v(e) ? e.every((t) => !t) : !e)
  }
}), T = (e, t) => {
  const r = c() ? f(E, i({})) : i({}), u = m(
    () => e.emptyValues || r.value.emptyValues || A
  ), o = m(() => a(e.valueOnClear) ? e.valueOnClear() : e.valueOnClear !== void 0 ? e.valueOnClear : a(r.value.valueOnClear) ? r.value.valueOnClear() : r.value.valueOnClear !== void 0 ? r.value.valueOnClear : t !== void 0 ? t : b), s = (l) => {
    let n = !0;
    return v(l) ? n = u.value.some((y) => O(l, y)) : n = u.value.includes(l), n;
  };
  return s(o.value) || d(V, "value-on-clear should be a value of empty-values"), {
    emptyValues: u,
    valueOnClear: o,
    isEmptyValue: s
  };
};
export {
  A as DEFAULT_EMPTY_VALUES,
  b as DEFAULT_VALUE_ON_CLEAR,
  V as SCOPE,
  E as emptyValuesContextKey,
  T as useEmptyValues,
  S as useEmptyValuesProps
};
